import { COLOR_SCHEME_DARK, COLOR_SCHEME_LIGHT } from "@graylog/sawmill";
const prefersDarkMode = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
const PREFERENCES_THEME_MODE = "themeMode";
const ROOT_FONT_SIZE = 16;
const LEGACY_COLOR_SCHEME_LIGHT = "teint";
const LEGACY_COLOR_SCHEME_DARK = "noir";
const DEFAULT_THEME_MODE = prefersDarkMode ? COLOR_SCHEME_DARK : COLOR_SCHEME_LIGHT;
const LEGACY_DEFAULT_THEME_MODE = prefersDarkMode ? LEGACY_COLOR_SCHEME_DARK : LEGACY_COLOR_SCHEME_LIGHT;
const COLOR_SCHEMES = [COLOR_SCHEME_LIGHT, COLOR_SCHEME_DARK];
const INPUT_BORDER_RADIUS = 0;
const NAV_ITEM_HEIGHT = "50px";
const NAV_ITEM_LINE_HEIGHT = "20px";
const NAV_LOGO_HEIGHT = "30px";
const MAX_NAV_LOGO_WIDTH = "120px";
const MAX_NAV_ICON_WIDTH = "30px";
const NAVBAR_GAP = 15;
export {
  DEFAULT_THEME_MODE,
  LEGACY_DEFAULT_THEME_MODE,
  LEGACY_COLOR_SCHEME_DARK,
  LEGACY_COLOR_SCHEME_LIGHT,
  PREFERENCES_THEME_MODE,
  ROOT_FONT_SIZE,
  COLOR_SCHEME_LIGHT,
  COLOR_SCHEME_DARK,
  COLOR_SCHEMES,
  INPUT_BORDER_RADIUS,
  NAV_ITEM_HEIGHT,
  NAV_ITEM_LINE_HEIGHT,
  NAV_LOGO_HEIGHT,
  MAX_NAV_LOGO_WIDTH,
  MAX_NAV_ICON_WIDTH,
  NAVBAR_GAP
};
